import { LitElement } from "lit";
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from "@lingui/core";

var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale = "en";
var detectByBrand = () => {
  var _a;
  let value;
  switch ((_a = process == null ? void 0 : process.env) == null ? void 0 : _a.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname == null ? void 0 : hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg, daMsg, svMsg) => {
  if (locale === "nb") return nbMsg;
  if (locale === "fi") return fiMsg;
  if (locale === "da") return daMsg;
  if (locale === "sv") return svMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages, daMessages, svMessages) => {
  const locale = detectLocale();
  const messages = getMessages(locale, enMessages, nbMessages, fiMessages, daMessages, svMessages);
  i18n.load(locale, messages);
  i18n.activate(locale);
};

var msgs = { "nb": { "icon.title.paw": ["Kattepot"] }, "en": { "icon.title.paw": ["Cat's paw"] }, "fi": { "icon.title.paw": ["Kissan tassu"] }, "da": { "icon.title.paw": ["Kattepote"] }, "sv": { "icon.title.paw": ["Kattass"] } };
activateI18n(msgs.en, msgs.nb, msgs.fi, msgs.da, msgs.sv);
var IconPaw42 = class extends LitElement {
  render() {
    const title = i18n.t({ message: `Cat's paw`, id: "icon.title.paw", comment: "Title for paw icon" });
    return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.25 18.063c1.346 0 2.438-1.82 2.438-4.063 0-2.244-1.092-4.063-2.438-4.063S8.812 11.758 8.812 14c0 2.244 1.092 4.063 2.438 4.063m5.688-8.125c1.346 0 2.437-1.82 2.437-4.063 0-2.244-1.091-4.063-2.438-4.063-1.346 0-2.437 1.82-2.437 4.063 0 2.244 1.091 4.063 2.438 4.063M30.75 17.25c1.346 0 2.438-1.819 2.438-4.063s-1.092-4.062-2.438-4.062-2.438 1.819-2.438 4.063 1.092 4.062 2.438 4.062m-5.687-7.312c1.346 0 2.437-1.82 2.437-4.063 0-2.244-1.091-4.063-2.438-4.063-1.346 0-2.437 1.82-2.437 4.063 0 2.244 1.091 4.063 2.438 4.063m.621 8.019a1.63 1.63 0 0 1-.626-1.361v-.159a4.062 4.062 0 1 0-8.125 0v.159a1.63 1.63 0 0 1-.626 1.361 4.3 4.3 0 0 0-1.807 3.355c0 2.693 2.91 4.875 6.5 4.875s6.5-2.182 6.5-4.875a4.3 4.3 0 0 0-1.816-3.355"></path></svg>`;
  }
};
if (!customElements.get("fp-icon-paw-42")) {
  customElements.define("fp-icon-paw-42", IconPaw42);
}
export {
  IconPaw42
};
